module.exports = __webpack_public_path__ + "static/media/58.0eedb52a.jpg";